import React from 'react';
import { useStoreState } from "easy-peasy";

class AdobeScript extends React.Component {

    constructor() {
        super();
        this.Setting = useStoreState((state) => state.siteSettingsModel);
    }

    setup = () => {
        let adobeScript = document.createElement('script');
       
        adobeScript.setAttribute('src',process.env.REACT_APP_ADOBE_URL);
        adobeScript.setAttribute('async', "");
        document.head.appendChild(adobeScript);
        console.log("Adobe Service Loaded!")
        return this
    }
}

export default AdobeScript